import { render } from "./winbidNoti.vue?vue&type=template&id=edc9352a"
import script from "./winbidNoti.vue?vue&type=script&lang=js"
export * from "./winbidNoti.vue?vue&type=script&lang=js"

import "./winbidNoti.vue?vue&type=style&index=0&id=edc9352a&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__